export default __webpack_public_path__ + "static/media/3_bottom.914e4ae0.png";